export default __webpack_public_path__ + "static/media/search.c8700a85.svg";